import Pie from './pie.vue';
export default Pie;